<template>
    <div class="hero__content">
        <video autoplay muted loop class="hero__deco" v-if="hero_is_video" :poster="home_hero_mobile_image">
            <source :src="home_hero_mobile_video" type="video/mp4">
        </video>
        <img v-else class="hero__deco" :src="home_hero_mobile_image" :alt="home_hero_alt">
        <slot></slot>
    </div>
</template>

<script>
import image_mixin from "../../_commons/nl/mixins/image_mixin"
export default {
    mixins:[
        image_mixin
    ]
}
</script>

<style scoped>

</style>
